import PropTypes from 'prop-types';
import Passport from '@mos-front-components/public/es/components/Passport';
import { createStructuredSelector } from 'reselect';

import { completeSTEPAPPLICANTTYPESelector } from '../../store/step/selectors';

import {
  mainDataValuesSelector,
  mainDataEditableFieldsSelector,
  mainDataErrorsSelector,
  mainDataBlurSelector,
  mainDataIsValidSelector,
  getUnderFourteenSelector,
  getBirthdateBeforeFourteenAndThirtyOneDaysAgo,
  getBirthdateBeforeFourteenAndHalfAgo,
  getForeignUnderSixteen
} from '../../store/mainData/selectors';

import {
  passportValuesSelector,
  passportErrorsSelector,
  passportEditableFieldsSelector,
  passportDisabledSelector,
  passportBlurSelector
} from '../../store/passport/selectors';

import { applicantTypeSelector } from '../../store/applicant/selectors';

export const stepApplicantStructuredSelector = createStructuredSelector({
  stepApplicantTypeComplete: completeSTEPAPPLICANTTYPESelector,
  mainDataValues: mainDataValuesSelector,
  mainDataEditableFields: mainDataEditableFieldsSelector,
  mainDataErrors: mainDataErrorsSelector,
  mainDataValid: mainDataIsValidSelector,
  passportValues: passportValuesSelector,
  passportEditableFields: passportEditableFieldsSelector,
  passportErrors: passportErrorsSelector,
  passportDisabled: passportDisabledSelector,
  mainDataBlur: mainDataBlurSelector,
  passportBlur: passportBlurSelector,
  underFourteen: getUnderFourteenSelector,
  birthdateBeforeFourteenAndThirtyOneDaysAgo: getBirthdateBeforeFourteenAndThirtyOneDaysAgo,
  birthdateBeforeFourteenAndHalf: getBirthdateBeforeFourteenAndHalfAgo,
  foreignUnderSixteen: getForeignUnderSixteen,
  applicantType: applicantTypeSelector
});

export const stepApplicantStructuredSelectorPropTypes = {
  mainDataValues: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    middleName: PropTypes.string,
    gender: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    birthdate: PropTypes.string,
    citizenship: PropTypes.string
  }),
  mainDataEditableFields: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool,
    middleName: PropTypes.bool,
    gender: PropTypes.bool,
    phone: PropTypes.bool,
    email: PropTypes.bool,
    birthdate: PropTypes.bool
  }),
  mainDataErrors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    middleName: PropTypes.string,
    gender: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    birthdate: PropTypes.string
  }),
  passportValues: PropTypes.shape({
    documentType: PropTypes.string,
    byWhom: PropTypes.string,
    dateOfIssue: PropTypes.string,
    number: PropTypes.string
  }),
  passportEditableFields: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(Passport.FIELD_NAME))
  ),
  passportErrors: PropTypes.shape({
    byWhom: PropTypes.string,
    dateOfIssue: PropTypes.string,
    number: PropTypes.string
  }),
  passportDisabled: PropTypes.bool.isRequired,
  mainDataBlur: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool,
    middleName: PropTypes.bool,
    gender: PropTypes.bool,
    phone: PropTypes.bool,
    email: PropTypes.bool,
    birthdate: PropTypes.bool
  }),
  passportBlur: PropTypes.shape({
    documentType: PropTypes.bool,
    byWhom: PropTypes.bool,
    dateOfIssue: PropTypes.bool,
    number: PropTypes.bool
  })
};
